'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
require('@narvar/nth-bit-icon-spinner');
var Panel = require('@narvar/nth-block-panel');
var CheckMarkIcon = require('@narvar/nth-bit-icon-check-mark');
var PanelContentHeader = require('@narvar/nth-block-panel-content-header');
var TextLink = require('@narvar/nth-bit-text-link');
var PanelHeader = require('@narvar/nth-bit-panel-header');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookContextPage = require('@narvar/nth-hook-context-page');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var LandscapeExpanded = require('./LandscapeExpanded.js');
var LandscapeCollapsed = require('./LandscapeCollapsed.js');
var Portrait = require('./Portrait.js');
var PrefetchData = require('./PrefetchData.js');
var Feedback_module = require('./Feedback.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Panel__default = /*#__PURE__*/_interopDefaultLegacy(Panel);
var CheckMarkIcon__default = /*#__PURE__*/_interopDefaultLegacy(CheckMarkIcon);
var PanelContentHeader__default = /*#__PURE__*/_interopDefaultLegacy(PanelContentHeader);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);
var PanelHeader__default = /*#__PURE__*/_interopDefaultLegacy(PanelHeader);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const localStorage = (() => {
  if (typeof window === 'undefined') return undefined;
  try {
    // reading the localStorage property can throw if we're in an iframe
    // see: https://stackoverflow.com/questions/67645164
    return window.localStorage;
  } catch (err) {
    return undefined;
  }
})();
const Feedback = ({
  featureName,
  errorCallback,
  layout = FeatureLayout.PORTRAIT,
  fixedPanelHeight
}) => {
  const {
    state: {
      trackingNumbers
    }
  } = nthHookContextPage.usePageContext();
  const trackingNumber = trackingNumbers && trackingNumbers[0];
  const {
    feedbackCustomerSupportLink = '',
    feedbackPanelTitleText = '',
    feedbackSuccessHeaderText = '',
    feedbackSuccessBodyText = ''
  } = nthHookTranslations.useTranslations();
  const {
    panelcontainerNoneNone: containerStyle,
    panelbodyNoneNone: panelBodyStyle,
    spinnerPrimaryNone: spinnerStyle,
    linksNoneDefault: textLinkStyle,
    linksNoneHover: textLinkHoverStyle
  } = nthHookTheme.useTheme();
  const {
    feedback
  } = nthHookSettings.useSettings();
  const {
    enableInitialCollapse: initialCollapsed,
    customerSupportLink,
    enablePanelHeader: enablePanelHeaderIn,
    commentOptional
  } = feedback ?? {};
  const enablePanelHeader = enablePanelHeaderIn === null || enablePanelHeaderIn === undefined || enablePanelHeaderIn;
  const isLandscape = layout === FeatureLayout.LANDSCAPE;
  const [feedbackSubmitted, setFeedbackSubmitted] = React.useState(false);
  const [selectedRating, setSelectedRating] = React.useState(0);
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  React.useEffect(() => {
    logEvent({
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_FEEDBACK,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_FEEDBACK,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_FEEDBACK,
      trackLayout: layout
    });
  }, [featureName, layout, logEvent]);
  React.useEffect(() => {
    if (localStorage && trackingNumber) {
      try {
        const feedbackStorage = localStorage.getItem(`feedback_${trackingNumber}`);
        if (feedbackStorage) setFeedbackSubmitted(true);
      } catch (err) {
        if (errorCallback) errorCallback(err);
      }
    }
  }, [trackingNumber, errorCallback]);
  const submitFeedback = feedbackComment => {
    logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.SURVEY_SUBMIT,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.SURVEY_SUBMIT,
      clickSurveyComment: feedbackComment,
      clickSurveyRating: selectedRating,
      clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_FEEDBACK,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_FEEDBACK,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_FEEDBACK,
      trackLayout: layout
    });

    // TODO: replace this with call to set this value in backend service
    if (localStorage && trackingNumber) {
      try {
        localStorage.setItem(`feedback_${trackingNumber}`, 'submittedFeedback');
      } catch (err) {
        if (errorCallback) errorCallback(err);
      }
    }
    setFeedbackSubmitted(true);
  };
  const onClickSupportLink = () => {
    logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.EXTERNAL_HELP_LINK,
      clickLinkDestinationUrl: customerSupportLink,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.EXTERNAL_HELP_LINK,
      clickType: nthHookContextAnalytics.NarvarClickTypes.OUTGOING,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_FEEDBACK,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_FEEDBACK,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_FEEDBACK,
      trackLayout: layout
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(Panel__default["default"], {
    header: (enablePanelHeader || layout === FeatureLayout.PORTRAIT) && /*#__PURE__*/React__default["default"].createElement(PanelHeader__default["default"], {
      featureName: featureName
    }, feedbackPanelTitleText),
    sOuter: {
      boxSizing: 'border-box',
      textAlign: isLandscape ? 'left' : 'center',
      overflowX: 'hidden',
      ...containerStyle,
      height: fixedPanelHeight || containerStyle && containerStyle.height || '100%'
    },
    sInner: {
      margin: '0 auto',
      maxWidth: !isLandscape ? '19.25rem' : 'auto',
      overflowX: 'hidden',
      ...panelBodyStyle,
      height: fixedPanelHeight ? 'auto' : '100%'
    }
  }, (() => {
    if (feedbackSubmitted) {
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: Feedback_module["default"].submittedContainer
      }, /*#__PURE__*/React__default["default"].createElement("div", {
        className: Feedback_module["default"].submittedContent
      }, /*#__PURE__*/React__default["default"].createElement(PanelContentHeader__default["default"], {
        as: enablePanelHeader ? 'p' : 'h2',
        featureName: featureName,
        headerTextRole: "status",
        icon: /*#__PURE__*/React__default["default"].createElement(CheckMarkIcon__default["default"], {
          featureName: featureName
        }),
        headerText: feedbackSuccessHeaderText ?? '',
        paragraphChildren: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", null, feedbackSuccessBodyText), customerSupportLink && /*#__PURE__*/React__default["default"].createElement("div", {
          className: Feedback_module["default"].csLink
        }, /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
          target: TextLink.TextLinkTargetType.BLANK,
          href: customerSupportLink,
          linkStyle: {
            sDefault: textLinkStyle,
            sHover: textLinkHoverStyle
          },
          onClick: () => onClickSupportLink()
        }, feedbackCustomerSupportLink))),
        isLandscape: isLandscape
      })));
    }
    if (isLandscape && initialCollapsed) {
      return /*#__PURE__*/React__default["default"].createElement(LandscapeCollapsed["default"], {
        featureName: featureName,
        selectedRating: selectedRating,
        onRatingSelect: setSelectedRating,
        submitFeedback: submitFeedback,
        commentOptional: commentOptional ?? false,
        enablePanelHeader: enablePanelHeader
      });
    }
    if (isLandscape && !initialCollapsed) {
      return /*#__PURE__*/React__default["default"].createElement(LandscapeExpanded["default"], {
        featureName: featureName,
        selectedRating: selectedRating,
        onRatingSelect: setSelectedRating,
        onClickSupportLink: onClickSupportLink,
        submitFeedback: submitFeedback,
        commentOptional: commentOptional ?? false,
        enablePanelHeader: enablePanelHeader
      });
    }
    return /*#__PURE__*/React__default["default"].createElement(Portrait["default"], {
      featureName: featureName,
      selectedRating: selectedRating,
      onRatingSelect: setSelectedRating,
      onClickSupportLink: onClickSupportLink,
      submitFeedback: submitFeedback,
      commentOptional: commentOptional ?? false
    });
  })());
};
const FeedbackWithData = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(Feedback, {
  themeTokens: ['panelcontainerNoneNone', 'panelbodyNoneNone', 'spinnerPrimaryNone', 'linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['feedbackCustomerSupportLink', 'feedbackPanelTitleText', 'feedbackSuccessHeaderText', 'feedbackSuccessBodyText']
}), {
  settingsRequested: `
      feedback {
        enableInitialCollapse
        customerSupportLink
        enablePanelHeader
        commentOptional
      }
    `
});
const FeedbackWithPrefetchedData = ({
  featureName,
  ...props
}) => /*#__PURE__*/React__default["default"].createElement(PrefetchData["default"], {
  featureName: featureName
}, /*#__PURE__*/React__default["default"].createElement(FeedbackWithData, _extends__default["default"]({
  featureName: featureName
}, props)));

exports.LandscapeExpanded = LandscapeExpanded["default"];
exports.LandscapeCollapsed = LandscapeCollapsed["default"];
exports.Portrait = Portrait["default"];
exports["default"] = FeedbackWithPrefetchedData;
